import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { editSupplyBillsItemsFiltersAgreeEconomist } from '../../../../../store/supplyBillSlice'

const SupplyBillItemsAllFilterAgreeEconomist = () => {

	const agree = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeEconomist)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(agree)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'yes',
			name: 'Так'
		},
		{
			id: 'no',
			name: 'Ні'
		},
		{
			id: 'other',
			name: 'Немає'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Погодження економістом"
        labelId="select__filterAgreeEconomist-label"
        id='select__filterAgreeEconomist'
        onChange = {e => {
            setValue(e)
			dispatch(editSupplyBillsItemsFiltersAgreeEconomist(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодження економістом'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillItemsAllFilterAgreeEconomist